import { $ } from 'rype-bootstrap';

// eslint-disable-next-line import/prefer-default-export
export function warn(warnMessage) {
  const warnModal = $('#warn-modal');

  warnModal.modal('show');

  warnModal.find('.modal-body').html(warnMessage);

  $('#understood')
    .off()
    .click(() => {
      warnModal.modal('hide');
    });
}



// WEBPACK FOOTER //
// ./src/utils/warnDialogHelper.js